import React from 'react'
import { Container } from './components/Styled'

interface Props {
  isSearch?: boolean
}
export const NoPosts = ({ isSearch }: Props) => {
  return (
    <Container>
      {isSearch ? (
        <p>No results found!</p>
      ) : (
        <p>No posts yet!</p>
      )}
    </Container>
  )
}
